<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-9 col-sm float-left">
            <h1 class="page-title">OPD List</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-3 mt-3">
                    <div class="col-sm-3 mt-1"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" /></div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Treatment" [(ngModel)]="treatment"
                            (click)="setSearchValue('treatment')" multiple>
                            <input class="mySearchInput" #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="treatmentSearch">
                            <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">
                                {{ltreatment.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Select City" [(ngModel)]="city" (click)="setSearchValue('city')"
                            multiple>
                            <input class="mySearchInput" #citySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'city')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="citySearch">
                            <mat-option>Select City</mat-option>
                            <mat-option [value]="city.city_id" *ngFor="let city of cities">{{city.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Payment Mode" [(ngModel)]="payment_mode" multiple>
                            <mat-option value="Cash">Cash</mat-option>
                            <mat-option value="Cashless">Cashless</mat-option>
                            <mat-option value="Reimbursement">Reimbursement</mat-option>
                            <mat-option value="EMI">EMI</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2 mt-1">
                        <mat-select placeholder="Status" [(ngModel)]="status" multiple>
                            <mat-option value="0">Active</mat-option>
                            <mat-option value="1">Completed</mat-option>
                            <mat-option value="3">Cancelled</mat-option>
                            <mat-option value="2">Deleted</mat-option>

                        </mat-select>
                    </div>
                    <div class="col-sm-3 mt-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>

                    <div class="col-sm-3 mt-4">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadOpds(0,perpage)"> <i
                                class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadOpds(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button></div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Surgery Suggested</th>
                            <th>Status</th>
                            <th>Glamyo Patient Id</th>
                            <th>Glamyo Appointment Id</th>
                            <th class="tablefixcoloumn">Patient Name</th>
                            <th *ngIf="userId!='16' && role!='6' && role!='10' && role!='18'">Patient Mobile</th>
                            <th>Lead City</th>
                            <th>Created Date</th>
                            <th>Treatment</th>
                            <th>Payment Mode</th>
                            <!-- <th>Consultation Fee</th> -->
                            <th>Consultation Type</th>
                            <!-- <th>Doctor</th>
                            <th>Hospital</th> -->
                            <th>Appointment Time</th>
                            <!-- <th>Prescription</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let opd of opdsList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>
                                <span class='badge' [ngClass]="{'badge-info':opd.surgery_suggested==0}"
                                    *ngIf="opd.surgery_suggested==0">Pending</span>
                                <span class='badge' [ngClass]="{'badge-success':opd.surgery_suggested==1}"
                                    *ngIf="opd.surgery_suggested==1">Yes</span>
                                <span class='badge' [ngClass]="{'badge-danger':opd.surgery_suggested==2}"
                                    *ngIf="opd.surgery_suggested==2">No</span>
                            </td>
                            <td>
                                <span class='p-2 badge' [ngClass]="{'badge-info':opd.status==0}"
                                    *ngIf="opd.status==0"><i class="fa fa-dot-circle"></i> Active</span>
                                <span class='p-2 badge' [ngClass]="{'badge-success':opd.status==1}"
                                    *ngIf="opd.status==1"><i class="fa fa-check"></i> Completed</span>
                                <span class='p-2 badge' [ngClass]="{'badge-danger':opd.status==3}"
                                    *ngIf="opd.status==3"><i class="fa fa-times"></i> Cancelled</span>
                            </td>

                            <td>{{opd.glamyo_patient_id}}</td>
                            <td>GHOPD{{opd.id}}</td>
                            <td class="tablefixcoloumn">{{opd.patient}}</td>
                            <td *ngIf="userId!='16' && role!='6' && role!='10' && role!='18'">{{opd.phone}}</td>
                            <td>{{opd.lead_city}}</td>
                            <td>{{opd.created_at*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                            <td>{{opd.treatment_name}}</td>
                            <td>{{opd.payment_mode}}</td>
                            <!-- <td>{{opd.billed_amt}}</td> -->
                            <td>
                                <span *ngIf="opd.consultation_type==1">Online Consultation</span>
                                <span *ngIf="opd.consultation_type==2">Offline Consultation</span>
                            </td>
                            <!-- <td>{{opd.doctor_name}}</td>
                            <td>{{opd.hospital_name}}</td> -->
                            <td>{{opd.appointment_time*1000|date:'d MMM, yyyy hh:mm aa'}}</td>
                            <!-- <td>
                                <div *ngIf="opd.prescription_link.length > 0; else noPrescription">
                                    <span *ngFor="let plink of opd.prescription_link"><a href="{{sc3Url+plink.links}}"
                                            target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noPrescription>
                                    Not uploaded
                                </ng-template>
                            </td> -->

                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !opdsList.length">
                            <td colspan="20"><i class="far fa-frown"></i> Opds not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>